var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Field } from 'react-final-form';
import { FieldErrorText } from '@/components/functional/Form/FieldErrorText';
import { DatePickerFieldBase, } from '@/components/ui/Form/DatePickerField/DatePickerFieldBase';
/**
 * 日付入力 Field
 */
export const DatePickerField = (props) => {
    const { name } = props, otherProps = __rest(props, ["name"]);
    return (_jsxs(_Fragment, { children: [_jsx(Field, Object.assign({}, otherProps, { component: DatePickerFieldBase, name: name })), _jsx(FieldErrorText, { name: name })] }));
};
